module.exports = __webpack_public_path__ + "static/spiral_up2-fb5cea141de10987af4271ab4a7971c4.jpg";